var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ index_bg:this.$route.path=='/index',ceo_page:this.$route.path=='/ceo'&&_vm.isMobile },attrs:{"id":"app"}},[_c('new-header'),_c('transition',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }